module.exports = __webpack_public_path__ + "img/submit-hen.1d223880.png";